import { Dispatch, PropsWithChildren, useCallback } from 'react';
import { LinkId } from '../../../../../AnalyticsContext/LinkId';
import { applyTrackingId } from '../../../../../AnalyticsContext/applyTrackingId';
import { safeMemo } from '../../../../../util/safeMemo';
import { SuggestionTabLabel } from '../../SuggestionTabLabel';
import { Tab } from './ButtonBar.styles';

type Props = PropsWithChildren<{
  value: SuggestionTabLabel;
  onSelect?: Dispatch<SuggestionTabLabel>;
  selected: boolean;
}>;

export const ButtonBarItem = safeMemo(({ value, onSelect, selected, children }: Props) => {
  const handleClick = useCallback(() => onSelect?.(value), [onSelect, value]);
  return (
    <Tab {...applyTrackingId(LINK_ID_FOR_TAB[value])} selected={selected} onClick={handleClick}>
      {children}
    </Tab>
  );
});

const LINK_ID_FOR_TAB: Record<SuggestionTabLabel, LinkId> = {
  All: LinkId['SEARCH_BAR_SUGGESTIONS_TAB_ALL'],
  Specialties: LinkId['SEARCH_BAR_SUGGESTIONS_TAB_SPECIALTIES'],
  Practices: LinkId['SEARCH_BAR_SUGGESTIONS_TAB_PRACTICES'],
  Practitioners: LinkId['SEARCH_BAR_SUGGESTIONS_TAB_PRACTITIONERS'],
  Topics: LinkId['SEARCH_BAR_SUGGESTIONS_TAB_TOPICS'],
};
